export default __webpack_public_path__ + "images/labelAssist-8hER1.gif";